import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import { User } from '../../types/users';
import { BaseQuery, Response, TagTypes } from '../apiBase.types';
import { IInstitution } from '../../utils/interfaces/interfaces';

const getUserEndpoints = (
  builder: EndpointBuilder<BaseQuery, TagTypes, 'API'>
) => ({
  getCurrentUser: builder.query<Response<User>, void>({
    query: () => ({
      url: 'users/me',
      method: 'GET'
    }),
    providesTags: [TagTypes.CurrentUser]
  }),
  getSubordinateInstitutions: builder.query<Response<any>, void>({
    query: () => ({
      url: 'institutions/subordinateInstitutions',
      method: 'GET'
    }),
    providesTags: [TagTypes.SubordinateInstitutions]
  })
});

export default getUserEndpoints;
